import { render, staticRenderFns } from "./BoardHeader.vue?vue&type=template&id=477902da&"
import script from "./BoardHeader.vue?vue&type=script&lang=ts&"
export * from "./BoardHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports